export const POST_TYPE = {
	CUSTOM: '주문제작',
	FAQ: '문의사항'
};

export const SHIPPING_FEE = 4500;

export const RECEIPT_TYPE = {
	forPersonal : {
		PERSONAL_PHONE: '휴대폰번호',
		PERSONAL_CARD: '현금영수증 카드번호'
	},
	forBusiness : {
		BUSINESS: '사업자등록번호'
	}
};

export const ORDER_STATUS = {
	AWAITING_DEPOSIT: { key: 'AWAITING_DEPOSIT', label: '입금대기중' },
	PREPARING_FOR_SHIPMENT: { key: 'PREPARING_FOR_SHIPMENT', label: '배송준비중' },
	SHIPPED: { key: 'SHIPPED', label: '배송중' },
	DELIVERED: { key: 'DELIVERED', label: '배송완료' },
	CANCELLED: { key: 'CANCELLED', label: '주문 취소' }
};

export const MALL_ACCOUNT = {
	BANK_NAME: '신한',
	ACCOUNT_NUMBER: '100-034-729922',
	ACCOUNT_HOLDER: '영원씨앤피'
};